import React from "react";
import SubBanner from "./components/SubBanner";
import Follow from "./components/Follow";

function Other() {
  return (
    <>
      <SubBanner title="Others" />

      <section className="shop1-con prod position-relative">
        <div className="container-fluid p-5">

          <div className="row shop-products-con">
            <ProductCard
              image="../assets/product-images/Tiramisu.png"
              name="Tiramisu"
              desc="A luxurious Italian classic layered with creamy coffee delight."
            />

            <ProductCard
              image="../assets/product-images/Coffee.png"
              name="Coffee"
              desc="Bold, smooth, and refreshing with the rich aroma of freshly brewed coffee."
            />

            <ProductCard
              image="../assets/product-images/Biscoff.png"
              name="Biscoff"
              desc="Creamy gelato swirled with the caramelised crunch of Biscoff biscuits."
            />
          </div>

        </div>
      </section>

      <Follow />
    </>
  );
}

// Product Card
function ProductCard({ image, name, desc }) {
  return (
    <div className="col-xl-3 col-lg-3 col-md-4 col-sm-6">
      <div className="classic-box hover-card">
        <div className="classic_image_box box1">
          <img src={image} alt={name} />
        </div>

        <div className="hover-content">
          <h6 className="hover-title">{name}</h6>
          <p className="hover-desc">{desc}</p>
        </div>
      </div>
    </div>
  );
}

export default Other;